import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconFax = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--fax")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1555.000000, -523.000000)"/>
          <g id="Rectangle-Copy-3" transform="translate(1.000000, 1.000000)">
              <path d="M17,0 C17.5522847,-1.01453063e-16 18,0.44771525 18,1 L18,4 L21,4 C21.5522847,4 22,4.44771525 22,5 L22,13 C22,13.5522847 21.5522847,14 21,14 L18,14 L18,21 C18,21.5522847 17.5522847,22 17,22 L5,22 C4.44771525,22 4,21.5522847 4,21 L4,14 L1,14 C0.44771525,14 6.76353751e-17,13.5522847 0,13 L0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 L4,4 L4,1 C4,0.44771525 4.44771525,1.01453063e-16 5,0 L17,0 Z M3,6 C2.44771525,6 2,6.44771525 2,7 C2,7.55228475 2.44771525,8 3,8 C3.55228475,8 4,7.55228475 4,7 C4,6.44771525 3.55228475,6 3,6 Z M16,2 L6,2 L6,4 L16,4 L16,2 Z" id="icon--centivo--fax" fill="currentColor"/>
              <path d="M16,11 L16,20 L6,20 L6,11 L16,11 Z M14.6,16.8 L7.4,16.8 L7.32809949,16.8096668 C7.14150013,16.86047 7,17.1054481 7,17.4 C7,17.7313708 7.1790861,18 7.4,18 L7.4,18 L14.6,18 L14.6719005,17.9903332 C14.8584999,17.93953 15,17.6945519 15,17.4 C15,17.0686292 14.8209139,16.8 14.6,16.8 L14.6,16.8 Z M14.6,14 L7.4,14 L7.32809949,14.0096668 C7.14150013,14.06047 7,14.3054481 7,14.6 C7,14.9313708 7.1790861,15.2 7.4,15.2 L7.4,15.2 L14.6,15.2 L14.6719005,15.1903332 C14.8584999,15.13953 15,14.8945519 15,14.6 C15,14.2686292 14.8209139,14 14.6,14 L14.6,14 Z" id="icon--centivo--fax" fill="#FFFFFF"/>
          </g>
      </g>
  </IconWrapper>
)
